
import AppSteps from './AppSteps.vue';
import AppStep from './AppStep.vue';
import AppList from './AppList.vue';

const neededInformation = [
  'Lage der Immobilie',
  'Größe der Immobilie',
  'Ausstattung der Immobilie',
];

export default {
  name: 'EstimationStepsSection',
  components: {
    AppSteps,
    AppStep,
    AppList,
  },
  data() {
    return {
      neededInformation,
    };
  },
};
